import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  header: {
    padding: theme.spacing(4),
  },
  content: {
    padding: theme.spacing(6),
  },
}));

export default useStyles;
